// import debounce from '../util/debounce';
import HomeSwiper from '../modules/home.swiper';
export default {
    init() {},
    finalize() {
        HomeSwiper.init();
    },
};


// WEBPACK FOOTER //
// ./scripts/routes/home.js